import { shallowEqual, useSelector } from 'react-redux';
import { getGameHistory } from '../selectors';

export const useHistory = () => ({
  history: useSelector(getGameHistory, shallowEqual),
});
